import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { benefitsNotes } from '@/mocks/benefitsData';

export default function NotesSection() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="border border-background-200/60 bg-background-100/40 p-8">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-[1px]">
              <i className="ri-information-line text-foreground-500 text-sm"></i>
            </div>
            <h3 className="text-[15px] text-foreground-700 tracking-[0.06em] font-medium">
              {t('benefits.notes.title')}
            </h3>
          </div>
          <ul className="space-y-3">
            {benefitsNotes.map((note, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <span className="text-[12px] text-foreground-400 flex-shrink-0 mt-[3px]">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <p className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                  {lang === 'en' ? t(`benefits.notes.${idx}`) : note}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
